import React from "react";
import { ScoutBar as Scout } from "scoutbar";
import useActions from "../../hooks/useActions";
// import useTheme from "../../hooks/useTheme";

const ScoutBar = () => {
  const actions = useActions();
  // const { theme } = useTheme();
  return (
    <Scout
      acknowledgement={false}
      placeholder={"What would you like to deploy today ?"}
      actions={() => actions}
      brandColor="#3366CC"
      theme={"light"}
      noAnimation={false}
      autocomplete="on"
    />
  );
};

export default ScoutBar;
